//id 是你要打印的某个dom元素的id名
export function printExcel(id) {
    // 空页面
    let printStr = "<html><head><meta http-equiv='Content-Type' content='text/html; charset=utf-8'></head>";
    // 定义element-ui table组件的样式
    const tabStyle = `<style>
    body{padding:0px}
    .divbody{width:100%;margin:0 auto;}
    .text-center{text-align:center;font-size:16px;padding:10px;color:#000;}
    .tableshd{margin:0 auto;text-align:center;width:98%;border:1px solid #000;border-bottom:0;border-left:0;}  
    .tableshd tr td,.tableshd tr th{border:1px solid #000;font-size:12px;padding:2px;line-height: 21px;color:#000;height:23px;word-wrap:break-word;border-top:0;border-right:0;text-align:center}
    .tableshd tr td span{width:80px;display: inline-block;}
</style><body>`;
    let content = "";
    // 获取名为传入id的 dom元素内的内容
    let str = document.getElementById(id).innerHTML;

    // 拼接空页面+style样式+dom内容
    content = content + str;
    printStr = printStr + tabStyle + content + "</body></html>";
    // 打开新页面
    let pwin = window.open("_blank");
    document.getElementById(id).style.zoom=0.2;
    // 将内容赋值到新页面
    pwin.document.write(printStr);
    pwin.document.close();
    // 聚焦-不加focuse，在某些情况下，打印页面会有问题。
    pwin.focus();
    // 使用setTimeout，等页面dom元素渲染完成后再打印。
    setTimeout(() => {
        pwin.print(); // 打印功能。 例如 window.print() 直接打印当前整个页面。 
        pwin.close(); // 关闭 打印创建的当前页面
    }, 500);

}
